<template>
  <div id="app">
    <v-header :inputName='Name'></v-header>

    <v-serch ref="vserch" :pickerValueArray="pickerValueArray" :batch="batch" @search="search" style="height: 75px;"></v-serch>
    <v-massage ref="massage" style="width: 1280px;padding-top: 0;"></v-massage>
    <v-crumbs @search="searchMajor" v-if="typename == 'majorscore'&&showcrumbs"></v-crumbs>
    <div class="tablecon" style="width: 1280px;margin: 0 auto;">
      <newgkmajorHeader :guding="guding" :jhYear="jhYear" :showtype="(typename+1)"></newgkmajorHeader>
      <div class="three" id="yuanshu2">
        <newgkmajorInfo :ref="`${tianbaoType==2?item.dataid:item.id}`" :item="item" :scoreyear="scoreYear"
          v-for="(item, index) in data" @select="openMajor"
          :key="index" :index="index" :showtype="typename" :showrate="true">
        </newgkmajorInfo>
        <loadData :loadding="loadding" :noMore="noMore" :total="pages" message="该筛选条件下无相关数据，请修改对应批次后再查询"></loadData>
      </div>
    </div>
    <item7></item7>
    <zuoxuanfu1></zuoxuanfu1>
    <zyCollegeMajor v-if="isTrue" :obj="selectItemObj" showtype="majorscore" datatype="cs" :jhflag="false"
      :querykey="message" @close="isTrue = false"></zyCollegeMajor>
  </div>
</template>
<script>
  import zuoxuanfu1 from '../components/zuoxuanfu1.vue'
  import vSerch from "../components/vSerchfen.vue";
  import vHeader from "../components/vHeader.vue";
  import item7 from "../components/item7.vue";
  import vMassage from "../components/vMassage.vue";
  import vCrumbs from "../components/vCrumbs.vue";
  import newgaokao750 from "../../css/newgaokao750.css"
  import yaunfenHeader from '../components/tianbaoHeader/yuanfenHeader.vue'
  import newgkmajorHeader from '../components/tianbaoHeader/newgkmajorHeader.vue'
  import newgkmajorInfo from '../components/tianbaoInfo/newgkmajorInfo.vue'
  import zyCollegeMajor from '../components/zyCollegeMajor.vue'
  import loadData from '../components/loadData.vue'
  export default {
    props: [],
    components: {
      vSerch,
      vHeader,
      item7,
      vCrumbs,
      newgaokao750,
      yaunfenHeader,
      zuoxuanfu1,
      vMassage,
      newgkmajorHeader,
      newgkmajorInfo,
      zyCollegeMajor,
      loadData
    },
    data() {
      return {
        // 导航选中
        Name: 0,
        guding: false,
        // 用来标识遮罩层显示与隐藏的
        isTrue: false,
        pageSize: 10,
        pageNum: 1,
        pages: 0,
        loadMoreText: "加载中...",
        showLoadMore: false,
        typename: 'collegescore',
        batch: "",
        pickerValueArray: [],
        list: [],
        data: [],
        collegeName: "",
        majorName: '',
        jhYear:2026,
        c: 0,
        xianshi: false,
        AREA_OBJ: this.$utils.getlocalStorage("AREA_OBJ"),
        scoreInfo: this.$utils.getlocalStorage("scoreInfo"),
        bb1: false,
        themeColor: '#F53824',
        mode: '',
        pickerValueDefault: [],
        loadding: false,
        noMore: false,
        userCang: [],
        majorcangList: [],
        tianbaoType: this.$utils.getlocalStorage("tianbaoType"),
        collegeAreas: "",
        collegeSubjection: '',
        collegeSubject: '',
        collegeLevel: '',
        majorInfo: '',
        collegeNature: '',
        majorList: [],
        showcrumbs: false,
        selectItemObj: {},
        isTrue: false,
        scoreYear: 2022,
        majorScoreYear: 2022,
        message: '',
        queryKey: ''
      };
    },
    computed: {},
    created() {

      console.log(this.$route.query)
      if (this.$route.query.collegeName) {

        this.collegeName = this.$route.query.collegeName;
        this.$nextTick(() => {
          this.$refs.vserch.setname({
            name: this.collegeName,
            major: ""
          })
        })
      }
      this.userCang = this.$utils.getlocalStorage("userCang").collegescore
      this.majorcangList = this.$utils.getlocalStorage("userCang").majorscore
    },

    methods: {
      search(obj) {
        let _this = this;
        this.typename = obj.typename
        this.batch = obj.batchname
        this.pickerValueArray.forEach(function(item){
          if(item.provincialBatch == obj.batchname){
            let obj = JSON.parse(item.spare1)
            if(obj.showcode == undefined){
              obj.showcode = false;
            }
            _this.$utils.setlocalStorage("showcode", obj.showcode)
          }
        })
        this.majorName = obj.majorname
        this.collegeName = obj.collegename
        this.pageNum = 1
        this.pages = 0
        this.data = []
        this.searchName()
        this.$refs.massage.getdata();


        this.getData()
      },
      getcangflag(id, ) {

      },
      selectItem(item) {

      },
      searchMajor(obj) {
        this.collegeAreas = obj.collegeAreas
        this.collegeSubjection = obj.collegeSubjection
        this.collegeSubject = obj.collegeSubject
        this.collegeLevel = obj.collegeLevel
        this.majorInfo = obj.majorInfo
        this.collegeNature = obj.collegeNature
        // this.searchName()
        this.pageNum = 1
        this.pages = 0
        this.data = []
        this.$refs.massage.getdata();
        this.getData()
      },
      searchName() {
        this.showcrumbs = false
        this.$nextTick(() => (this.showcrumbs = true))
        this.collegeAreas = ''
        this.collegeLevel = ''
        this.collegeSubject = ''
        this.collegeSubjection = ''
        this.majorInfo = ''
      },
      getprovincialTable() {
        console.log(1)
        let _this = this;
        this.$req.queryAllbyFirstYear({
          provincialArea: this.scoreInfo.scoreArea,
          provincialSubject: this.scoreInfo.scoreSubject,
        }).then(function(response) {
          _this.pickerValueArray = response.data
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].provincialScore <= _this.scoreInfo.score) {
              _this.batch = response.data[i].provincialBatch
              _this.$utils.setlocalStorage("userZhiYuanBatch", _this.pickerValueArray[i])
              let obj = JSON.parse(response.data[i].spare1)
              if(obj.showcode == undefined){
                obj.showcode = false;
              }
              _this.$utils.setlocalStorage("showcode", obj.showcode)
              break;
            }
          }
          _this.$refs.massage.getdata();
          _this.getData();
        })
      },
      getData() {
        this.noMore = false;
        let _this = this;
        if (this.loadding) {
          return;
        }
        this.loadding = true;
        if (this.tianbaoType != 0) {
          let xuanke = this.scoreInfo.scoreXuanke.split(",");
          this.$req.queryZyByCollegeLimit({
            pageNum: _this.pageNum,
            pageSize: _this.pageSize,
            emptyKey: this.typename.replace('score', ''),
            queryKey: _this.message,
            queryObj: {
              userArea: _this.scoreInfo.scoreArea,
              userScore: _this.scoreInfo.score,
              batch: this.batch,
              tianbaoType: this.tianbaoType + "",
              tianbaoGrade: "",
              scoretype: _this.scoreInfo.scoreSubject,
              xk1: xuanke[0],
              xk2: xuanke[1],
              xk3: xuanke[2],
              collegeName: this.collegeName,
              majorName: this.majorName,
              collegeLevel: this.collegeLevel,
              majorInfo: this.majorInfo,
              collegeNature: this.collegeNature,
              collegeAreas: this.collegeAreas,
              collegeSubjection: this.collegeSubjection,
              collegeSubject: this.collegeSubject,
              userId:_this.scoreInfo.userId,
              use_score: false,
              jhflag: false,
              emptyKey: this.typename.replace('score', '')
            },
          }).then(function(response) {
            _this.loadding = false;
            if (response.status == '0') {
              _this.data = _this.data.concat(response.data)
              _this.pages = response.pages;
              _this.message = response.str
              if (response.year) {
                _this.scoreYear = response.year
              }
              _this.jhYear = response.dataAll;
              console.log(_this.data)
            }
          })
        } else {
          let _this = this;
          if (this.typename == 'collegescore') {
            this.$req.collegeTianbao({
              pageNum: _this.pageNum,
              pageSize: _this.pageSize,
              queryKey: _this.message,
              queryObj: {
                userArea: _this.scoreInfo.scoreArea,
                userScore: _this.scoreInfo.score,
                batch: this.batch,
                tianbaoType: this.tianbaoType + "",
                tianbaoGrade: "",
                xiancha: (_this.scoreInfo.score - this.provincialscore) + "",
                scoretype: _this.scoreInfo.scoreSubject,
                collegeName: this.collegeName,
                major_name: this.majorName,
                use_score: false,
                jhflag: false
              },
            }).then(function(response) {
              _this.loadding = false;
              _this.data = _this.data.concat(response.data)
              _this.pages = response.pages;
              _this.message = response.str
              if (response.year) {
                _this.scoreYear = response.year
              }
              _this.jhYear = response.dataAll;
            })
          } else {
            this.$req.queryOldZyByMajorLimit({
              pageNum: _this.pageNum,
              pageSize: _this.pageSize,
              queryKey: _this.queryKey,
              queryObj: {
                userArea: _this.scoreInfo.scoreArea,
                userScore: _this.scoreInfo.score,
                batch: this.batch,
                tianbaoType: this.tianbaoType + "",
                tianbaoGrade: "",
                scoretype: _this.scoreInfo.scoreSubject,
                collegeName: this.collegeName,
                majorName: this.majorName,
                jhflag: false,
                collegeLevel: this.collegeLevel,
                majorInfo: this.majorInfo,
                collegeNature: this.collegeNature,
                collegeAreas: this.collegeAreas,
                collegeSubjection: this.collegeSubjection,
                collegeSubject: this.collegeSubject,
              },
            }).then(function(response) {
              _this.loadding = false;
              if (response.status == '0') {
                _this.data = _this.data.concat(response.data)
                _this.pages = response.pages;
                _this.queryKey = response.str
                if (response.year) {
                  _this.scoreYear = response.year
                }
                _this.jhYear = response.dataAll;
              }
            })
          }

        }


      },
      guanzhu(id, flag, type) {

        let _this = this;
        let flag1 = this.$utils.getLoginStatus();
        if (flag1) {
          let obj = this.$utils.getlocalStorage("userCang")
          let list = obj[this.typename]
          let majorlist = obj.majorscore
          if (!flag) {
            _this.$req.insert("collectionTable", {
              dataType: type == "collegescore" ? 3 : 4,
              dataId: id
            }).then(function(resp) {
              if (resp.status == 0) {
                if (_this.typename == type) {
                  list.push(id);
                  _this.userCang = list;
                  obj[type] = list
                }
                if (type == 'majorscore') {
                  majorlist.push(id);
                  _this.majorcangList = majorlist;
                  obj[type] = majorlist
                }
                _this.$utils.setlocalStorage("userCang", obj);
              }
            })

          } else {
            _this.$req.batchDelete("collectionTable", {
              data_type: type == "collegescore" ? 3 : 4,
              data_id: id
            }).then(function(resp) {
              if (resp.status == 0) {
                if (_this.typename == type) {
                  list.splice(list.indexOf(id), 1);
                  _this.userCang = list
                  obj[type] = list
                }
                if (type == 'majorscore') {
                  majorlist.splice(majorlist.indexOf(id), 1);
                  _this.majorcangList = majorlist;
                  obj.majorscore = majorlist
                }
                _this.$utils.setlocalStorage("userCang", obj);
              }
            })
          }
        }
      },
      openMajor(index) {
        this.selectItemObj = this.data[index]
        this.isTrue = true;
      },
      zzc() {
        this.isTrue = true;
        console.log(this.isTrue);
      },
      zzcB() {
        this.isTrue = false;
      },
      showinfo(info) {
        if (info == null || info == '') {
          return '--';
        }
        return info;
      },
      handleScrollx() {
        if (this.$route.path == '/cegailv') {
          let tedItem = document.querySelector("#yuanshu1")
          let tedItem2 = document.querySelector("#yuanshu2")
          var scrollTop = tedItem.getBoundingClientRect().top
          var scrollTop2 = tedItem2.getBoundingClientRect().top
          let a = 100
          let b = 160
          if (this.typename != 'collegescore') {
            a = 200
            b = 400
          }

          if (scrollTop <= a) {
            this.guding = true
          }

          if (scrollTop2 >= b) {
            this.guding = false
          }
          const scrollY =
            document.body.scrollTop || document.documentElement.scrollTop; // 滚动条在Y轴上的滚动距离
          const compatibility =
            document.compatMode === "CSS1Compat" ?
            document.documentElement.clientHeight :
            document.body.clientHeight;
          // clientHeight 属性是一个只读属性，它返回该元素的像素高度，高度包含内边距（padding），不包含边框（border），外边距（margin）和滚动条，是一个整数，单位是像素 px。
          // 页面总高度
          const TotalHeight = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight
          );
          // 当滚动条滑到页面底部
          if (compatibility + scrollY >= (TotalHeight - 1500)) {
            console.log(this.loadding)
            if (this.pageNum < this.pages && !this.loadding) {
              this.pageNum++;
              this.getData()
            }
            if (this.pageNum >= this.pages){
              if (this.pages != 0) {
                this.noMore = true
              }
            }
          }
        }

      },

      //===========================点击展开关闭效果====================================
      openShutManager(oSourceObj, oTargetObj, shutAble, oOpenTip, oShutTip) {
        var sourceObj = typeof oSourceObj == "string" ? document.getElementById(oSourceObj) : oSourceObj;
        var targetObj = typeof oTargetObj == "string" ? document.getElementById(oTargetObj) : oTargetObj;
        var openTip = oOpenTip || "";
        var shutTip = oShutTip || "";
        if (targetObj.style.display != "none") {
          if (shutAble) return;
          targetObj.style.display = "none";
          if (openTip && shutTip) {
            sourceObj.innerHTML = shutTip;
          }
        } else {
          targetObj.style.display = "block";
          if (openTip && shutTip) {
            sourceObj.innerHTML = openTip;
          }
        }
      },

    },
    mounted() {
      window.addEventListener('scroll', this.handleScrollx, true)
      this.getprovincialTable();
    },
  };
</script>
<style scoped>
  /* .two {
    display: flex;
    width: 100%;
    height: 100px;
    background-color: #f66464;
    margin-top: 20px;
    border-radius: 2px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 50px;
    color: #ffffff;
    justify-content: center;
    align-items: center;
  } */
  .three {
    min-height: 500px;
  }

  .btn {
    padding: 0;
  }

  .test {
    width: 200px !important;
  }



  .container {
    width: 1280px;
  }





  .three_for .Cont3 p,
  .three_for .Cont4 p,
  .three_for .Cont5 p,
  .three_for,
  .three_for .Cont7 p {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #333333;
  }

  /* 遮罩层  ↓ */
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 844;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .maskA {
    width: 910px;
    height: 90vh;
    background: rgb(255, 255, 255);
    border-radius: 20px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }

  .maskAA {
    width: 910px;
    height: 64px;
    background-image: url("../../src/assets/img/zzctop.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 28px;
    padding-left: 28px;
    box-sizing: border-box;
    margin-bottom: 10px;
  }

  .maskAA img {
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  .ANAN {
    width: 100%;
    height: calc(100% - 64px);
    overflow-y: scroll;
  }

  .maskAA p {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  .two_A {
    width: 850px;
    height: 46px;
    background: #f66464;
    border-radius: 5px;
    display: flex;
    align-items: center;
    margin: auto;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    opacity: 1;
  }

  .T_title1_A {
    width: 38%;
    text-align: center;
    line-height: 46px;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title8_A {
    width: 46%;
    text-align: center;
    line-height: 46px;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title9_A {
    width: 16%;
    text-align: center;
    line-height: 46px;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title8bot_A {
    display: flex;
    justify-content: space-evenly;
  }

  .three_A {
    width: 850px;
    height: auto;
    margin: auto;
    margin-top: 11px;
    padding-bottom: 64px;
    box-sizing: border-box;
  }

  .three_for_A {
    display: flex;
    width: 100%;
    height: 115px;
    border: 1px solid #ebe9e9;
    border-radius: 10px;
    margin-top: 11px;
  }

  .Cont_A {
    border-right: 1px solid #ebe9e9;
  }

  .Cont1_A {
    width: 38%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 14px;
    padding-left: 30px;
    box-sizing: border-box;
  }

  .Cont1_A .Cont_Nr_A h3 {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 20px;
    color: #29a7e1;
    margin-bottom: 10px;
  }

  .Cont_Nr_A p {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 24px;
    color: #666666;
  }

  .Cont8_S {
    width: 46%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: ;
    border: none;

  }

  .Cont9_S {
    width: 16%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
  }

  .Cont9_S .Cont9_AAA {
    display: flex;
    justify-content: center;
    width: 92px;
    height: 36px;
    background-image: url("../../src/assets/img/weiguanzhu.png");
    background-size: 92px 36px;
    align-items: center;
    cursor: pointer;
  }

  /* 点击关注 切换 */
  .Cont9_S .Cont9_BBB {
    display: flex;
    justify-content: center;
    width: 92px;
    height: 36px;
    background-image: url('../../src/assets/img/yiguanzhu.png');
    background-size: 92px 36px;
    align-items: center;
    cursor: pointer;
  }

  .Cont9_BBB p {
    color: #FFFFFF !important;
  }

  .Cont9_AAA img {
    width: 15px;
    height: 16px;
    margin-right: 8px;
  }

  .Cont9_AAA p {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 20px;
    color: #666666;
  }
</style>



// WEBPACK FOOTER //
// src/views/cegailv.vue